export default function selectRoot(state) {
  return state && state.collection
}
